module.exports = __webpack_public_path__ + "static/com_circle-bbfe1a2fada8afbad96f8603344a9f04.png";